module.exports = __webpack_public_path__ + "media/application/images/2018/2018-fav-star-ab1629e667d983eda487c9875132c6db.svg";